var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    id: "_24_-_Save",
    "data-name": "24 - Save",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_272",
    "data-name": "Path 272",
    d: "M31,10.652a3,3,0,0,0-.962-2.2L22.854,1.8A3,3,0,0,0,20.816,1H4A3,3,0,0,0,1,4V28a3,3,0,0,0,3,3H28a3,3,0,0,0,3-3Zm-2,0V28a1,1,0,0,1-1,1H4a1,1,0,0,1-1-1V4A1,1,0,0,1,4,3H20.816a1,1,0,0,1,.68.266l7.183,6.652A1,1,0,0,1,29,10.652Z",
    transform: "translate(-1 -1)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_273",
    "data-name": "Path 273",
    d: "M17,2a1,1,0,0,0-1-1H7.6a1,1,0,0,0-1,1V4.667a3,3,0,0,0,3,3H14a3,3,0,0,0,3-3V2ZM15,3V4.667a1,1,0,0,1-1,1H9.6a1,1,0,0,1-1-1V3H15Z",
    transform: "translate(-1 -1)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_274",
    "data-name": "Path 274",
    d: "M23.215,22.667a3,3,0,0,0-3-3h-8.43a3,3,0,0,0-3,3V30a1,1,0,0,0,1,1h12.43a1,1,0,0,0,1-1Zm-2,0V29H10.785V22.667a1,1,0,0,1,1-1h8.43a1,1,0,0,1,1,1Z",
    transform: "translate(-1 -1)",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.0d9b5129338c6f54848a0dc48811e772.svg";
export { ForwardRef as ReactComponent };